export enum Additional {
  PARTNER = 'Partner',
}

export const Additionals = [{ value: 'Partner', label: 'Partner' }];
